import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { Frame } from '@/components/ui/frame'

// The bordered "box" the register/test onboarding steps render into. It is a <Frame> (the shared
// bg-card surface) that ALSO owns the `flow-frame` / `flow-content` view-transition names (see app.css)
// which morph the box between steps — the border resizes while the content fades out → in. For that
// morph to read as one continuous motion, every step route AND its `pendingComponent` skeleton
// (flow-pending.tsx) must render the SAME structure, so that contract lives here in one place instead
// of being copy-pasted as bare `className="flow-frame"` / `"flow-content"` strings that can silently
// drift. The plain register/team-evaluation cards reuse the same <Frame> surface without these names.
export function FlowFrame(props: {
  children: ReactNode
  className?: string
  /** Extra classes on the `flow-content` wrapper (e.g. `flex flex-col gap-5` for direct children). */
  contentClassName?: string
}) {
  return (
    <Frame data-slot="flow-frame" className={cn('flow-frame w-full', props.className)}>
      <div data-slot="flow-content" className={cn('flow-content px-4', props.contentClassName)}>
        {props.children}
      </div>
    </Frame>
  )
}
